import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReceiveReloadTemplateCollection extends WebSocketReceiveMessage {
  override payload: {
    TemplateCollectionId: string;
  };
}
